var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecept(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    width: 1066.6667,
    height: 1066.6667,
    viewBox: "0 0 1066.6667 1066.6667",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,800 H 800 V 0 H 0 Z",
    id: "path14"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1066.6667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(302.5166,304.4648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -2.186,3.865 -3.881,7.913 -5.109,12.067 H -187.517 V -8.72 c 0,-4.864 3.98,-8.843 8.844,-8.843 H 15.374 C 9.175,-12.892 3.937,-6.962 0,0",
    fill: "#3EB370",
    fillOpacity: 1,
    fillRule: "evenodd",
    stroke: "none",
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(297.1802,347.9971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0.076,0.273 0.164,0.54 0.244,0.812 H -144.689 V 147.288 H 118.164 V 32.836 l 26.127,-4.086 v 126.134 c 0,9.557 -7.757,17.313 -17.315,17.313 h -280.477 c -9.557,0 -17.314,-7.756 -17.314,-17.313 V -21.713 H -1.749 C -2.554,-14.525 -1.992,-7.179 0,0",
    fill: "#3EB370",
    fillOpacity: 1,
    fillRule: "evenodd",
    stroke: "none",
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(460.2852,268.3076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 4.614,-1.262 9.727,-1.52 14.73,-0.468 l 1.809,0.381 c 1.868,0.393 3.734,0.901 5.556,1.515 l 1.357,0.479 0.961,0.371 1.182,0.494 c 0.784,0.337 1.563,0.69 2.335,1.057 l 1.579,0.792 1.34,0.708 1.18,0.651 1.878,1.085 3.068,1.875 2.561,1.646 c 3.231,2.111 5.952,4.004 8.676,5.915 5.368,3.784 10.376,7.463 15.312,11.151 2.275,1.702 4.528,3.403 6.77,5.104 l 2.171,-115.331 h 152.25 l -35.908,214.289 c -4.849,29.116 -30.42,51.066 -60.811,50.494 -8.514,-0.16 -16.578,-2.079 -23.866,-5.391 C 96.796,174.599 89.895,170.569 84.134,164.732 67.824,148.209 51.392,131.811 34.856,115.794 26.597,107.8 18.294,99.874 10.064,92.273 5.969,88.49 1.875,84.782 -2.017,81.377 l -100.744,15.754 c -16.418,2.586 -32.527,-7.496 -37.079,-23.896 -4.899,-17.648 5.437,-35.926 23.085,-40.826 z",
    fill: "#3EB370",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    id: "path28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "translate(648.125,526.8257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -7.882,-39.625 -46.395,-65.357 -86.021,-57.475 -39.625,7.883 -65.358,46.395 -57.475,86.021 7.883,39.625 46.396,65.358 86.02,57.475 C -17.849,78.139 7.883,39.626 0,0",
    fill: "#3EB370",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    id: "path32"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecept);
export default __webpack_public_path__ + "static/media/recept.4109e642e39b0079d55b84618a52a0af.svg";
export { ForwardRef as ReactComponent };